import InputToggleCondensed from "./InputToggleCondensed";
import InputToggleResponsive from "./InputToggleResponsive";
const InputToggle = {
  Condensed: InputToggleCondensed,
  Responsive: InputToggleResponsive
};
var InputToggle_default = InputToggle;
export {
  InputToggle_default as default
};
